import { ImageAttributionViewModel } from "../common";
import {
	FrequentlyAskedQuestionItemViewModel,
	HubItemElementKind,
	HubItemMediaKind,
	HubItemRowLayoutKind,
	ImageFocalPointModel
} from "./common";

export type HubItemLayoutDetailsViewModel = {
	rows: readonly HubItemRowDetailsViewModel[];
};

export type HubItemRowDetailsViewModel = {
	layout: HubItemRowLayoutKind;
	columns: readonly HubItemColumnDetailsViewModel[];
};

export type HubItemColumnDetailsViewModel = {
	elements: readonly HubItemElementDetailsViewModel[];
};


export type HorizontalLineElementDetailsViewModel = {
	id: number;
	kind: HubItemElementKind.HorizontalLine;
};

export type ImageElementDetailsViewModel = {
	id: number;
	kind: HubItemElementKind.Image;
	blobId: string;
	name: string;
	attribution: ImageAttributionViewModel | null;
};

export type ParagraphElementDetailsViewModel = {
	id: number;
	kind: HubItemElementKind.Paragraph;
	html: string | null;
};

export type SubtitleElementDetailsViewModel = {
	id: number;
	kind: HubItemElementKind.Subtitle;
	text: string;
};

export type VideoElementDetailsViewModel = {
	id: number;
	kind: HubItemElementKind.Video;
	url: string;
};

export type EmbedElementDetailsViewModel = {
	id: number;
	kind: HubItemElementKind.Embed;
	code: string;
};

export type FrequentlyAskedQuestionsElementDetailsViewModel = {
	id: number;
	kind: HubItemElementKind.FrequentlyAskedQuestion;
	items: readonly FrequentlyAskedQuestionItemViewModel[];
};

export type HubItemElementDetailsViewModel =
	| HorizontalLineElementDetailsViewModel
	| ImageElementDetailsViewModel
	| ParagraphElementDetailsViewModel
	| SubtitleElementDetailsViewModel
	| VideoElementDetailsViewModel
	| EmbedElementDetailsViewModel
	| FrequentlyAskedQuestionsElementDetailsViewModel;

export type NoneHubMediaDetailsViewModel = {
	mediaKind: HubItemMediaKind.None;
};

export type ImageHubMediaDetailsViewModel = {
	mediaKind: HubItemMediaKind.Image;
	imageId: string;
	imageName: string;
	focalPoint: ImageFocalPointModel;
	attribution: ImageAttributionViewModel | null;
};

export type VideoHubMediaDetailsViewModel = {
	mediaKind: HubItemMediaKind.Video;
	videoUrl: string;
};

export type EmbedHubItemMediaDetailsViewModel = {
	mediaKind: HubItemMediaKind.Embed;
	embedCode: string;
};

export type HubItemMediaDetailsViewModel =
	| NoneHubMediaDetailsViewModel
	| ImageHubMediaDetailsViewModel
	| VideoHubMediaDetailsViewModel
	| EmbedHubItemMediaDetailsViewModel;

export enum HubItemViewLocation {
	Hub = 1,
	Dialog = 2,
	PopupQueue = 3
};

export type RegisterViewModel = {
	location: HubItemViewLocation;
};

export type HubCommentOptionsModel = {
	supportedImageTypes: readonly string[];
	maxImageSize: number;
};